import { render, staticRenderFns } from "./CardAuthorityEmployeeGroup.vue?vue&type=template&id=2a25af65"
import script from "./CardAuthorityEmployeeGroup.vue?vue&type=script&lang=js"
export * from "./CardAuthorityEmployeeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports